import React from "react";
import CreateProductBtn from "../../../components/CreateProductBtn";
import ProductsCard from "./ProductsCard";
import { useGetProductListingQuery } from "../../../rtk-query/slices/product/productListingSlice";
import { ShimmerContentBlock } from "react-shimmer-effects";
import { useNavigate } from "react-router-dom";
import NoBookingCard from "../../bookings/components/NoBookingCard";

function ProductsWrapper() {
  const { data: productList, isLoading } = useGetProductListingQuery({
    limit: 100,
    page: 1,
  });
  const navigate = useNavigate();
  return (
    <div className="dod-product-listing-main-wrapper">
      {/* title and create product button */}
      <div className=" w-100 d-flex flex-sm-row  flex-column flex-wrap align-items-center justify-content-sm-between justify-content-center">
        <h2 className="ob-supplier-content-heading">Products</h2>
        {/* <div className="d-flex align-items-center gap-3 w-max">
          <CreateProductBtn isHide={false} />
        </div> */}
      </div>
      {/* products list */}
      {isLoading ? (
        <ShimmerContentBlock
          title
          text
          cta
          thumbnailWidth={370}
          thumbnailHeight={370}
        />
      ) : !productList || productList?.data?.data?.length === 0 ? (
        <>
          <NoBookingCard text="No product found!" paddingY={0} marginY={0} />
          {/* <p className="ob-pi-note m-0 p-0 mt-4">
            Start creating products in few simple steps that wont take more than
            few minutes and you have it published
          </p>
          <div
            className="d-flex flex-column align-items-center justify-content-center add-product-photo-container add-price-schedule-container"
            onClick={(e) => {
              e.preventDefault();
              localStorage.removeItem("productId");
              navigate("/create-product");
            }}
            style={{ cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="94"
              height="94"
              viewBox="0 0 94 94"
              fill="none"
            >
              <circle cx="47" cy="47" r="47" fill="#F5F6F8" />
              <path
                d="M47.5 34L47.5 61"
                stroke="#05073C"
                stroke-opacity="0.3"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M61 47.5L34 47.5"
                stroke="#05073C"
                stroke-opacity="0.3"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            <p className="price-schedule-add-text">Create new product</p>
          </div> */}
        </>
      ) : (
        <div className="d-flex flex-column gap-4 mt-4">
          {productList?.data?.data?.map((res, id) => (
            <ProductsCard productData={res} />
          ))}
        </div>
      )}
    </div>
  );
}

export default ProductsWrapper;
